import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createValoracion } from '../api/valoracionFuncionalApi';

export const useValoracionForm = ({ idPaciente }) => {
  const navigate = useNavigate();
  const [medicionesDerecha, setMedicionesDerecha] = useState(['', '', '']);
  const [medicionesIzquierda, setMedicionesIzquierda] = useState(['', '', '']);
  const [mediaDerecha, setMediaDerecha] = useState('');
  const [mediaIzquierda, setMediaIzquierda] = useState('');
  const [maxDerecha, setMaxDerecha] = useState('');
  const [maxIzquierda, setMaxIzquierda] = useState('');
  const [openGood, setOpenGood] = useState(false);
  const [openError, setOpenError] = useState(false);

  const setMedicion = (setter, values, index, value) => {
    const next = [...values];
    next[index] = value;
    setter(next);
  };

  const calcularResultados = () => {
    const derecha = medicionesDerecha.map(Number).filter((val) => !Number.isNaN(val));
    const izquierda = medicionesIzquierda.map(Number).filter((val) => !Number.isNaN(val));

    if (derecha.length === 3) {
      setMediaDerecha((derecha.reduce((a, b) => a + b, 0) / 3).toFixed(2));
      setMaxDerecha(Math.max(...derecha).toFixed(2));
    }
    if (izquierda.length === 3) {
      setMediaIzquierda((izquierda.reduce((a, b) => a + b, 0) / 3).toFixed(2));
      setMaxIzquierda(Math.max(...izquierda).toFixed(2));
    }
  };

  const guardarDatos = async () => {
    try {
      await createValoracion({
        pacienteId: idPaciente.toString(),
        userId: localStorage.getItem('id'),
        payload: {
          mediaDerecha,
          mediaIzquierda,
          dsDerecha: maxDerecha,
          dsIzquierda: maxIzquierda,
        },
      });
      setOpenGood(true);
      setTimeout(() => {
        navigate(`/paciente/${idPaciente}`);
      }, 1500);
    } catch (error) {
      console.error('Error al guardar valoración funcional:', error);
      setOpenError(true);
    }
  };

  return {
    medicionesDerecha,
    medicionesIzquierda,
    mediaDerecha,
    mediaIzquierda,
    maxDerecha,
    maxIzquierda,
    openGood,
    openError,
    setOpenGood,
    setOpenError,
    setMedicionDerecha: (index, value) => setMedicion(setMedicionesDerecha, medicionesDerecha, index, value),
    setMedicionIzquierda: (index, value) => setMedicion(setMedicionesIzquierda, medicionesIzquierda, index, value),
    calcularResultados,
    guardarDatos,
  };
};
